import React from "react";
import FormField from "./CampoFormulario";
import { TextField as MUITextField } from "@material-ui/core/";

const CampoTexto = React.forwardRef((props, ref) => (
    <>
        <FormField ref={ref} Component={MUITextField} {...props} />
    </>
));

export default CampoTexto;
